// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --appBlack: #000000;
  --inactiveIcon: #8a8c91;
  --activeIcon: white;
  --activeIconRed: red;
  --popupBackground: #2d2f39;
  --legendRed: #e72416;
  --legendYellow: #ffe08f;
  --frontBlue: #0178ae;
  --legendGreen: #83b643;
  --lighterGreen: #8cff0053;
  --textDetails: #ec6728;
  --inputError: #d60d25;
  --inputSuccess: #12b76a;
  --statusBlue: #3f7bf3;
  --sectionHeadlineText: #54778e;
  --sfOrangeLight: #ff8e58;
  --badgeBg: #f7ddd0;
}

.Map-module_mapContainer___LzXwb {
  flex-grow: 1;
  overflow: auto;
}

.Map-module_mapLegendContainer___KhlMS {
  display: flex;
  align-items: center;
  padding: 6px 8px;
  font-size: 1rem;
}
.theme--light .Map-module_mapLegendContainer___KhlMS {
  border-top: 1px solid #dddddd;
}
.theme--dark .Map-module_mapLegendContainer___KhlMS {
  border-top: 1px solid #2f2f2f;
}

.Map-module_mapSwitchContainer___OiXLj {
  display: flex;
  padding: 3px 4px;
  border-radius: 4px;
}
.theme--light .Map-module_mapSwitchContainer___OiXLj {
  background-color: #dddddd;
}
.theme--dark .Map-module_mapSwitchContainer___OiXLj {
  background-color: #2f2f2f;
}
.Map-module_mapSwitchContainer___OiXLj > button {
  min-height: auto;
  padding: 2px 8px;
  font-size: 1.1rem;
  line-height: 1.5rem !important;
}

.Map-module_rightContent___t1ECE {
  display: flex;
  height: 24px;
  padding: 3px 4px;
  border-radius: 4px;
}
.theme--light .Map-module_rightContent___t1ECE {
  background-color: #dddddd;
}
.theme--dark .Map-module_rightContent___t1ECE {
  background-color: #2f2f2f;
}

.Map-module_rightContentHolder___aVPDh {
  display: flex;
  gap: 0.8rem;
  align-items: flex-start;
  flex-direction: column;
  padding-top: 0.4rem;
  overflow: auto;
}
.Map-module_rightContentHolder___aVPDh .Map-module_filtersBar___yT06J {
  display: flex;
  gap: 0.8rem;
  align-items: center;
  margin-left: auto;
}
.Map-module_rightContentHolder___aVPDh .Map-module_filterNumberInfo___ffDOJ {
  font-size: 1rem;
}
.theme--light .Map-module_rightContentHolder___aVPDh .Map-module_filterNumberInfo___ffDOJ {
  color: #212121;
}
.theme--dark .Map-module_rightContentHolder___aVPDh .Map-module_filterNumberInfo___ffDOJ {
  color: #f0f0f0;
}

.Map-module_hideMapAndFeedback___gjh4y {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
}
.theme--light .Map-module_hideMapAndFeedback___gjh4y button {
  background-color: #ffffff;
}
.theme--dark .Map-module_hideMapAndFeedback___gjh4y button {
  background-color: #1c1c1c;
}

.Map-module_text___WN4QS {
  display: flex;
  align-items: center;
  max-width: 100%;
  font-weight: 400;
  font-size: 1rem;
}
.theme--light .Map-module_text___WN4QS {
  color: #888888;
}
.theme--dark .Map-module_text___WN4QS {
  color: #a3a3a3;
}

.Map-module_checkboxContainer___Rh4ev {
  display: flex;
  gap: 0.8rem;
}

.Map-module_inputHolder___DdA0Z {
  flex-grow: 1;
  display: flex;
  gap: 2.4rem;
  align-items: flex-end;
  position: relative;
}
.Map-module_inputHolder___DdA0Z > div {
  flex: 1;
}

.Map-module_filterRangeContainer___tp1tK {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 7px;
  left: 50%;
  transform: translate(-50%, 0);
}`, "",{"version":3,"sources":["webpack://./src/styles/_index.scss","webpack://./src/pages/home/children/pricing/components/map/Map.module.scss"],"names":[],"mappings":"AAOA;EACC,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,sBAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,qBAAA;EACA,8BAAA;EACA,wBAAA;EACA,kBAAA;ACND;;AAhBA;EACC,YAAA;EACA,cAAA;AAmBD;;AAhBA;EAKC,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAeD;AD0EE;EC/FA,6BAAA;AAwBF;ADuEE;EC/FA,6BAAA;AA2BF;;AAlBA;EACC,aAAA;EACA,gBAAA;EACA,kBAAA;AAqBD;AD8DE;EChFA,yBAAA;AAqBF;AD2DE;EChFA,yBAAA;AAwBF;AArBC;EACC,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;AAuBF;;AAnBA;EACC,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AAsBD;AD2CE;EC9DA,yBAAA;AAsBF;ADwCE;EC9DA,yBAAA;AAyBF;;AArBA;EACC,aAAA;EACA,WAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,cAAA;AAwBD;AAtBC;EACC,aAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;AAwBF;AArBC;EAKC,eAAA;AAmBF;ADmBE;ECzCC,cAAA;AAyBH;ADgBE;ECzCC,cAAA;AA4BH;;AArBA;EACC,kBAAA;EACA,QAAA;EACA,gCAAA;EACA,UAAA;AAwBD;ADME;EC1BC,yBAAA;AAuBH;ADGE;EC1BC,yBAAA;AA0BH;;AArBA;EAKC,aAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAoBD;ADRE;ECnBA,cAAA;AA8BF;ADXE;ECnBA,cAAA;AAiCF;;AAvBA;EACC,aAAA;EACA,WAAA;AA0BD;;AAvBA;EACC,YAAA;EACA,aAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;AA0BD;AAxBC;EACC,OAAA;AA0BF;;AAtBA;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,SAAA;EACA,6BAAA;AAyBD","sourcesContent":["@use \"sass:map\";\r\n\r\n$breakPointM: 1024px;\r\n$breakPointS: 768px;\r\n$breakPointHeightL: 900px;\r\n$breakPointHeightXL: 2200px;\r\n\r\n:root {\r\n\t--appBlack: #000000;\r\n\t--inactiveIcon: #8a8c91;\r\n\t--activeIcon: white;\r\n\t--activeIconRed: red;\r\n\t--popupBackground: #2d2f39;\r\n\t--legendRed: #e72416;\r\n\t--legendYellow: #ffe08f;\r\n\t--frontBlue: #0178ae;\r\n\t--legendGreen: #83b643;\r\n\t--lighterGreen: #8cff0053;\r\n\t--textDetails: #ec6728;\r\n\t--inputError: #d60d25;\r\n\t--inputSuccess: #12b76a;\r\n\t--statusBlue: #3f7bf3;\r\n\t--sectionHeadlineText: #54778e;\r\n\t--sfOrangeLight: #ff8e58;\r\n\t--badgeBg: #f7ddd0;\r\n}\r\n\r\n$themes: (\r\n\tlight: (\r\n\t\tbackgroundPrimary: #f5f6f8,\r\n\t\tsidebarBorder: #dddddd,\r\n\t\ttextPrimary: #212121,\r\n\t\trowWithSoldColor: #212121,\r\n\t\ttextSecondary: #888888,\r\n\t\tborderColor: #dddddd,\r\n\t\tbuttonTertiaryBackground: #ffffff,\r\n\t\tbuttonTertiaryColor: #1f1f1f,\r\n\t\tbuttonTertiaryBorderColor: #e8e8e8,\r\n\t\tinputBackground: #fafafa,\r\n\t\tinputBorderColor: #ddddda,\r\n\t\tsectionBackground: #ffffff,\r\n\t\ttableCellBackground: #ffffff,\r\n\t\ttableHeaderBackground: #f5f6f8,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #cfe1cb,\r\n\t\tholdHighlightedItem: #fff3c4,\r\n\t\trowWithHoldColor: #212121,\r\n\r\n\t\tbuttonPrimaryBackground: #000000,\r\n\t\tbuttonPrimaryBorderColor: #555555,\r\n\t\tbuttonPrimaryTextColor: #ffffff,\r\n\r\n\t\tbuttonSecondaryBackground: #ffffff,\r\n\t\tbuttonSecondaryBorderColor: #dddddd,\r\n\t\tbuttonSecondaryTextColor: #000000,\r\n\r\n\t\tsidebarBackground: #ffffff,\r\n\t\tbuttonOutlineBorder: #8b8b8b,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n\tdark: (\r\n\t\tbackgroundPrimary: #0d0d0d,\r\n\t\tsidebarBorder: #000000,\r\n\t\ttextPrimary: #f0f0f0,\r\n\t\trowWithSoldColor: #f0f0f0,\r\n\t\ttextSecondary: #a3a3a3,\r\n\t\tborderColor: #2f2f2f,\r\n\t\tbuttonTertiaryBackground: #0d0d0d,\r\n\t\tbuttonTertiaryColor: #fafafa,\r\n\t\tbuttonTertiaryBorderColor: #2f2f2f,\r\n\t\tinputBackground: #0d0d0d,\r\n\t\tinputBorderColor: #2f2f2f,\r\n\t\tsectionBackground: #1c1c1c,\r\n\t\ttableCellBackground: #1c1c1c,\r\n\t\ttableHeaderBackground: #1c1c1c,\r\n\t\tmodalBackground: #21212166,\r\n\t\thighlightedItem: #f7ddd0,\r\n\t\tsoldHighlightedItem: #4a5c46,\r\n\t\tholdHighlightedItem: #5c5630,\r\n\t\trowWithHoldColor: #f0f0f0,\r\n\r\n\t\tbuttonPrimaryBackground: #ffffff,\r\n\t\tbuttonPrimaryBorderColor: #dddddd,\r\n\t\tbuttonPrimaryTextColor: #000000,\r\n\r\n\t\tbuttonSecondaryBackground: #000000,\r\n\t\tbuttonSecondaryBorderColor: #555555,\r\n\t\tbuttonSecondaryTextColor: #ffffff,\r\n\r\n\t\tsidebarBackground: #000000,\r\n\t\tbuttonOutlineBorder: #dddddd,\r\n\r\n\t\terrorBorder: #fecdca,\r\n\t\terrorBackground: #fef3f2,\r\n\t\terrorText: #b42318,\r\n\t),\r\n);\r\n\r\n@mixin themed {\r\n\t@each $theme, $map in $themes {\r\n\t\t:global(.theme--#{$theme}) & {\r\n\t\t\t$theme-map: () !global;\r\n\t\t\t@each $key, $submap in $map {\r\n\t\t\t\t$value: map.get($map, $key);\r\n\t\t\t\t$theme-map: map.merge(\r\n\t\t\t\t\t$theme-map,\r\n\t\t\t\t\t(\r\n\t\t\t\t\t\t$key: $value,\r\n\t\t\t\t\t)\r\n\t\t\t\t) !global;\r\n\t\t\t}\r\n\t\t\t@content;\r\n\t\t\t$theme-map: null !global;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n@function get($key) {\r\n\t@return map-get($theme-map, $key);\r\n}\r\n\r\n@mixin button-primary {\r\n\tbackground: linear-gradient(135deg, var(--textDetails), #e45210);\r\n\tcolor: white;\r\n\tborder: none;\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: linear-gradient(135deg, #e45210, #d3470e);\r\n\t\ttransform: translateY(-2px);\r\n\t}\r\n}\r\n\r\n@mixin button-secondary {\r\n\t@include themed {\r\n\t\tbackground: get(\"buttonTertiaryBackground\");\r\n\t\tcolor: get(\"buttonTertiaryColor\");\r\n\t\tborder: 1px solid get(\"buttonTertiaryBorderColor\");\r\n\t}\r\n\tpadding: 12px 24px;\r\n\tborder-radius: 8px;\r\n\tfont-weight: 600;\r\n\tcursor: pointer;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\tbackground: var(--textDetails);\r\n\t\tcolor: white;\r\n\t\tborder-color: var(--textDetails);\r\n\t}\r\n}\r\n\r\n@mixin card {\r\n\t@include themed {\r\n\t\tbackground: get(\"sectionBackground\");\r\n\t\tborder: 1px solid get(\"borderColor\");\r\n\t}\r\n\tborder-radius: 12px;\r\n\tpadding: 24px;\r\n\ttransition: all 0.3s ease;\r\n\r\n\t&:hover {\r\n\t\ttransform: translateY(-4px);\r\n\t\tbox-shadow: 0 8px 32px rgba(245, 99, 28, 0.1);\r\n\t}\r\n}\r\n\r\n@mixin section-padding {\r\n\tpadding: 50px 0;\r\n\tborder-radius: 12px;\r\n}\r\n\r\n@mixin container {\r\n\tmax-width: 1200px;\r\n\tpadding: 0 24px;\r\n}\r\n",":root {\n  --appBlack: #000000;\n  --inactiveIcon: #8a8c91;\n  --activeIcon: white;\n  --activeIconRed: red;\n  --popupBackground: #2d2f39;\n  --legendRed: #e72416;\n  --legendYellow: #ffe08f;\n  --frontBlue: #0178ae;\n  --legendGreen: #83b643;\n  --lighterGreen: #8cff0053;\n  --textDetails: #ec6728;\n  --inputError: #d60d25;\n  --inputSuccess: #12b76a;\n  --statusBlue: #3f7bf3;\n  --sectionHeadlineText: #54778e;\n  --sfOrangeLight: #ff8e58;\n  --badgeBg: #f7ddd0;\n}\n\n.mapContainer {\n  flex-grow: 1;\n  overflow: auto;\n}\n\n.mapLegendContainer {\n  display: flex;\n  align-items: center;\n  padding: 6px 8px;\n  font-size: 1rem;\n}\n:global(.theme--light) .mapLegendContainer {\n  border-top: 1px solid #dddddd;\n}\n:global(.theme--dark) .mapLegendContainer {\n  border-top: 1px solid #2f2f2f;\n}\n\n.mapSwitchContainer {\n  display: flex;\n  padding: 3px 4px;\n  border-radius: 4px;\n}\n:global(.theme--light) .mapSwitchContainer {\n  background-color: #dddddd;\n}\n:global(.theme--dark) .mapSwitchContainer {\n  background-color: #2f2f2f;\n}\n.mapSwitchContainer > button {\n  min-height: auto;\n  padding: 2px 8px;\n  font-size: 1.1rem;\n  line-height: 1.5rem !important;\n}\n\n.rightContent {\n  display: flex;\n  height: 24px;\n  padding: 3px 4px;\n  border-radius: 4px;\n}\n:global(.theme--light) .rightContent {\n  background-color: #dddddd;\n}\n:global(.theme--dark) .rightContent {\n  background-color: #2f2f2f;\n}\n\n.rightContentHolder {\n  display: flex;\n  gap: 0.8rem;\n  align-items: flex-start;\n  flex-direction: column;\n  padding-top: 0.4rem;\n  overflow: auto;\n}\n.rightContentHolder .filtersBar {\n  display: flex;\n  gap: 0.8rem;\n  align-items: center;\n  margin-left: auto;\n}\n.rightContentHolder .filterNumberInfo {\n  font-size: 1rem;\n}\n:global(.theme--light) .rightContentHolder .filterNumberInfo {\n  color: #212121;\n}\n:global(.theme--dark) .rightContentHolder .filterNumberInfo {\n  color: #f0f0f0;\n}\n\n.hideMapAndFeedback {\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 5;\n}\n:global(.theme--light) .hideMapAndFeedback button {\n  background-color: #ffffff;\n}\n:global(.theme--dark) .hideMapAndFeedback button {\n  background-color: #1c1c1c;\n}\n\n.text {\n  display: flex;\n  align-items: center;\n  max-width: 100%;\n  font-weight: 400;\n  font-size: 1rem;\n}\n:global(.theme--light) .text {\n  color: #888888;\n}\n:global(.theme--dark) .text {\n  color: #a3a3a3;\n}\n\n.checkboxContainer {\n  display: flex;\n  gap: 0.8rem;\n}\n\n.inputHolder {\n  flex-grow: 1;\n  display: flex;\n  gap: 2.4rem;\n  align-items: flex-end;\n  position: relative;\n}\n.inputHolder > div {\n  flex: 1;\n}\n\n.filterRangeContainer {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  bottom: 7px;\n  left: 50%;\n  transform: translate(-50%, 0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapContainer": `Map-module_mapContainer___LzXwb`,
	"mapLegendContainer": `Map-module_mapLegendContainer___KhlMS`,
	"mapSwitchContainer": `Map-module_mapSwitchContainer___OiXLj`,
	"rightContent": `Map-module_rightContent___t1ECE`,
	"rightContentHolder": `Map-module_rightContentHolder___aVPDh`,
	"filtersBar": `Map-module_filtersBar___yT06J`,
	"filterNumberInfo": `Map-module_filterNumberInfo___ffDOJ`,
	"hideMapAndFeedback": `Map-module_hideMapAndFeedback___gjh4y`,
	"text": `Map-module_text___WN4QS`,
	"checkboxContainer": `Map-module_checkboxContainer___Rh4ev`,
	"inputHolder": `Map-module_inputHolder___DdA0Z`,
	"filterRangeContainer": `Map-module_filterRangeContainer___tp1tK`
};
export default ___CSS_LOADER_EXPORT___;
